import { useFetchData } from "../../../hooks/useFetch";
import { ApiConfig, API_ORDER_REPORT_ROUTER } from "../../../services/api-config";

/** Một đơn giặt lại trong modal bóc tách. */
export interface RewashOrderRow {
  id: number;
  code: string;
  created_at: string;
  status: number;
  customer_id: number;
  customer_name: string;
  origin_order_id: number;
  origin_code: string;
  /** Nơi GIẶT — chi nhánh mà dòng báo cáo quy trách nhiệm */
  wash_branch_id: number;
  wash_branch_name: string;
  /** Chủ đơn — khác nơi giặt = đơn điều chuyển */
  owner_branch_id: number;
  owner_branch_name: string;
  is_transferred: boolean;
  is_pickup_laundry: number;
  reason_code: string | null;
  reason_label: string;
  weight: number;
  gross: number;
  discount: number;
  moved_from_origin: number;
  responsible_names: string[];
}

export interface RewashOrdersPage {
  total_record: number;
  page: number;
  limit: number;
  list: RewashOrderRow[];
}

/** Khoá bóc tách — đúng một trong số này được set tuỳ bảng người dùng bấm vào. */
export interface RewashDrilldownKey {
  branch_id?: number;
  reason_code?: string;
  customer_id?: number;
  employee_id?: number;
}

export interface RewashSummary {
  order_count: number;
  immediate_count: number;
  delayed_count: number;
  /** Giá trị đồ giặt lại theo ký (chưa trừ giảm giá) */
  gross: number;
  /** Tiền MẤT THẬT — miễn/giảm cho khách */
  discount: number;
  collected: number;
  /** Tiền chuyển từ đơn gốc sang (khách vẫn trả đủ) — KHÔNG phải thiệt hại */
  moved_from_origin: number;
  weight: number;
  /** Mẫu số: đơn thường HOÀN THÀNH trong kỳ */
  completed_base_count: number;
  rewash_rate: number | null;
  /** Tổng ký đã giao ra trong kỳ (đơn thường hoàn thành) — mẫu số của tỉ lệ theo ký */
  base_weight: number;
  /** Số đơn nền chưa có cân lần 2 (final_weight = 0) → mẫu số hụt bấy nhiêu đơn */
  base_zero_weight_count: number;
  /** % = ký giặt lại / ký đã giao trong kỳ */
  rewash_weight_rate: number | null;
}

export interface RewashByDate { day: string; immediate: number; delayed: number }
export interface RewashByReason {
  reason_code: string | null;
  reason_label: string;
  order_count: number;
  gross: number;
  weight: number;
}
export interface RewashByBranch {
  branch_id: number;
  branch_name: string;
  order_count: number;
  immediate_count: number;
  delayed_count: number;
  gross: number;
  discount: number;
  weight: number;
  completed_base_count: number;
  rewash_rate: number | null;
  base_weight: number;
  rewash_weight_rate: number | null;
  /** Trong số đơn của dòng này, bao nhiêu đơn là "giặt hộ" chi nhánh khác (nơi giặt ≠ chủ đơn) */
  transferred_in_count: number;
}
export interface RewashByEmployee {
  employee_id: number;
  employee_name: string;
  order_count: number;
  gross: number;
  weight: number;
}
export interface RewashByCustomer {
  customer_id: number;
  customer_name: string;
  order_count: number;
  gross: number;
  weight: number;
}
export interface RewashRepeatedOrder {
  related_order_id: number;
  origin_code: string;
  times: number;
  branch_id: number;
  last_at: string;
}

export interface RewashReport {
  from_date: string;
  to_date: string;
  summary: RewashSummary;
  by_date: RewashByDate[];
  by_reason: RewashByReason[];
  by_branch: RewashByBranch[];
  by_employee: RewashByEmployee[];
  by_customer: RewashByCustomer[];
  repeated_orders: RewashRepeatedOrder[];
}

const RewashReportService = {
  report: () => {
    const { request, baseResponse, loading } = useFetchData.Get<RewashReport>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
    return {
      fetch: (params: {
        from_date: string;
        to_date: string;
        branch_id?: number;
        is_pickup_laundry?: number;
        limit?: number;
      }) => request({ endPoint: API_ORDER_REPORT_ROUTER.API_REWASH_REPORT, data: params }),
      response: baseResponse,
      loading,
    };
  },

  /** Danh sách đơn đứng sau một dòng báo cáo (modal bóc tách). */
  orders: () => {
    const { request, baseResponse, loading } = useFetchData.Get<RewashOrdersPage>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
    return {
      fetch: (params: {
        from_date: string;
        to_date: string;
        is_pickup_laundry?: number;
        page?: number;
        limit?: number;
      } & RewashDrilldownKey) =>
        request({ endPoint: API_ORDER_REPORT_ROUTER.API_REWASH_ORDERS, data: params }),
      response: baseResponse,
      loading,
    };
  },
};

export default RewashReportService;
